import { Alert, Link, Modal, PillButton, Row, Stack, Text } from 'library/ui';
import React from 'react';
import { useHistory } from 'react-router';
import useMicrodepositVerificationInfo from './useMicrodepositVerficationInfo';

export default function MissingMicrodepositVerificationModal({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) {
    const history = useHistory();
    const { needsSecondVerificationWarning } = useMicrodepositVerificationInfo();

    const linkToPayments = () => {
        onClose();
        history.push('/payments');
    };

    const text = (() => {
        if (needsSecondVerificationWarning) {
            return {
                title: 'Uh-oh! We still need to verify your banking information',
                topText:
                    "Posting additional jobs has been blocked until your micro deposits are submitted. This is for your safety and it's easy, we promise!",
                bottomText: 'If you need any additional help, reach out to your Account Manager.',
            };
        }

        return {
            title: 'Uh-oh! We need to verify your banking information',
            topText: "In order to securely connect your bank account please verify your micro deposits. It's easy!",
            bottomText: '',
        };
    })();

    if (!isOpen) return null;

    return (
        <Modal onClose={onClose} padding="none">
            <Stack gap="md" padding="lg">
                <Text weight="bold" size="xl">
                    {`${text.title} `}
                    <Link onClick={linkToPayments}>here</Link>
                </Text>
                <Alert variant="error">{text.topText}</Alert>

                <Stack gap="md">
                    <Row gap="sm">
                        <Text weight="bold" size="xl" tone="accent">
                            1.
                        </Text>
                        <Text weight="bold">Log into the bank account used for Tandem.</Text>
                    </Row>
                    <Row gap="sm">
                        <Text weight="bold" size="xl" tone="accent">
                            2.
                        </Text>
                        <Text weight="bold">Find the two small charges from Tandem, each less than $1.</Text>
                    </Row>
                    <Row gap="sm">
                        <Text weight="bold" size="xl" tone="accent">
                            3.
                        </Text>
                        <Text weight="bold">
                            Enter the two amounts under the Manual Account Verification on the Payments page and hit
                            Submit.
                        </Text>
                    </Row>
                </Stack>

                <Text>{text.bottomText}</Text>
                <Text>*This must be within 10 days of connecting your bank or it will no longer be valid.</Text>
                <PillButton onClick={linkToPayments}>Add Micro Deposit</PillButton>
            </Stack>
        </Modal>
    );
}
